interface Ad {
  id: string;
  formatId: string;
  aboutUrl: string;
  trackUrl: string;
  destinationDomain?: string;
  content: Record<string, string>;
  orgName: string;
  orgUrl?: string;
}

type Ads = {
  [id: string]: Ad;
};

interface AdsResponse {
  ads: Ads;
}

export async function requestAds() {
  const containers = document.querySelectorAll("[data-placement-id]");
  const placements: string[] = [];

  for (const container of containers) {
    const element = container as HTMLDivElement;
    const placement = element.dataset.placementId;
    if (placement) {
      placements.push(placement);
    }
  }

  if (placements.length === 0) return;

  const response = await fetch("/ads/api/request", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      placements,
    }),
  });

  const json = (await response.json()) as AdsResponse;

  for (const container of containers) {
    const element = container as HTMLDivElement;
    const placementId = element.dataset.placementId;
    const placementKind = element.dataset.placementKind;
    if (placementId) {
      const ad = json.ads[placementId];

      if (ad) {
        const textContent = ad.content["content"];
        const orgAssetUrl = ad.content["image"];

        switch (placementKind) {
          case "flat": {
            const contentElement =
              element.querySelector<HTMLDivElement>(".p-content");
            const aboutLinkElement =
              element.querySelector<HTMLAnchorElement>(".p-about-link");
            const destDomainElement =
              element.querySelector<HTMLSpanElement>(".p-d-domain");
            if (contentElement) {
              if (textContent) {
                contentElement.innerHTML = textContent;
              }
              if (aboutLinkElement) {
                aboutLinkElement.href = ad.aboutUrl;
              }
              if (destDomainElement && ad.destinationDomain) {
                destDomainElement.innerText = `(${ad.destinationDomain})`;
              }
              container.classList.remove("hidden");
            }
            break;
          }
          case "section": {
            const contentElement =
              element.querySelector<HTMLDivElement>(".p-content");
            const imageContainerElement =
              element.querySelector<HTMLDivElement>(".p-image-container");
            const imageLinkElement =
              element.querySelector<HTMLAnchorElement>(".p-image-link");
            const imageElement =
              element.querySelector<HTMLDivElement>(".p-image");
            const aboutLinkElement =
              element.querySelector<HTMLAnchorElement>(".p-about-link");
            const destDomainElement =
              element.querySelector<HTMLSpanElement>(".p-d-domain");
            let hasContent = false;
            if (aboutLinkElement) {
              aboutLinkElement.href = ad.aboutUrl;
            }
            if (destDomainElement && ad.destinationDomain) {
              destDomainElement.innerText = ad.destinationDomain;
            }
            if (contentElement && textContent) {
              contentElement.innerHTML = textContent;
              hasContent = true;
            }
            if (
              orgAssetUrl &&
              imageContainerElement &&
              imageLinkElement &&
              imageElement
            ) {
              imageContainerElement.classList.remove("hidden");
              imageLinkElement.href = ad.trackUrl;
              imageElement.style.backgroundImage = `url(${orgAssetUrl})`;
              hasContent = true;
            }
            if (hasContent) {
              container.classList.remove("hidden");
            }
            break;
          }
          case "sidebar": {
            const contentElement =
              element.querySelector<HTMLDivElement>(".p-content");
            const imageLinkElement =
              element.querySelector<HTMLAnchorElement>(".p-image-link");
            const imageElement =
              element.querySelector<HTMLDivElement>(".p-image");
            const aboutLinkElement =
              element.querySelector<HTMLAnchorElement>(".p-about-link");
            const destDomainElement =
              element.querySelector<HTMLSpanElement>(".p-d-domain");
            let hasContent = false;
            if (aboutLinkElement) {
              aboutLinkElement.href = ad.aboutUrl;
            }
            if (destDomainElement && ad.destinationDomain) {
              destDomainElement.innerText = ad.destinationDomain;
            }
            if (contentElement && textContent) {
              contentElement.innerHTML = textContent;
              hasContent = true;
            }
            if (orgAssetUrl && imageLinkElement && imageElement) {
              imageLinkElement.classList.remove("hidden");
              imageLinkElement.href = ad.trackUrl;
              imageElement.style.backgroundImage = `url(${orgAssetUrl})`;
              hasContent = true;
            }
            if (hasContent) {
              container.classList.remove("hidden");
            }
            break;
          }
        }
      }
    }
  }

  if (!response.ok) {
    throw new Error("Bad response");
  }
}
